import {Promise} from "bluebird";
import {apiRequest} from "./ApiRequest";

const getBds = params => {
    return apiRequest("get", "/bds", null, params).then(response => {
        return Promise.resolve(response.data);
    });
};

const getBdDetails = bd => {
    return apiRequest("get", "/bds/" + bd.id).then(response => {
        return Promise.resolve(response.data);
    });
};

const editBd = (id, data) => {
    return apiRequest("put", "/bds/" + id, data).then(response => {
        if (data.addedFiles.length) {
            const formData = new FormData();
            data.addedFiles.forEach(f => {
                formData.append("upload", f);
            });
            apiRequest("post", `/bds/${response.data.id}/logo`, formData);
        }
        if (data.deletedFiles) {
            Promise.map(data.deletedFiles, df => apiRequest("delete", df.src));
        }
        return Promise.resolve(response.data);
    });
};

const createBd = data => {
    return apiRequest("post", "/bds", data).then(response => {
        if (data.addedFiles.length) {
            const formData = new FormData();
            data.addedFiles.forEach(f => {
                formData.append("upload", f);
            });
            return apiRequest("post", `/bds/${response.data.id}/logo`, formData).then(() => Promise.resolve(response.data));
        }
        return Promise.resolve(response.data);
    });
};

const deleteBd = id => {
    return apiRequest("delete", "/bds/" + id).then(response => {
        return Promise.resolve(response.data);
    });
};

export {getBds, getBdDetails, editBd, createBd, deleteBd};
